module.exports = __webpack_public_path__ + "img/get-it-on-google-play-badge.468ef7f5.png";